<template>
  <div class="home">
    <AppStart_MS />
  </div>
</template>

<script>
// @ is an alias to /src
import AppStart_MS from '@/components/AppStart_MS.vue'

export default {
  name: 'HomeView',
  components: {
    AppStart_MS
  }
}
</script>
